const dynamicPackage = {
  detailedPlan: "详细计划", // translated
  minimum: "最低限度", // translated
  maximum: "最大限度", // translated
};

export default dynamicPackage;
